import { type FC, useCallback, useEffect, useState } from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { useGetEnrollmentLoadingData, useSubmitEnrollmentLoadingData } from '@egw/api'
import { GenericError } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { Logger } from '@egw/logger'
import { EnrollmentLayout } from '@egw/layouts'
import { useRouter } from '@egw/router'
import { WEALTH_ROUTES } from '@egw/constants'
import { ROUTES } from '../../../constants'
import { LoadingAnimation } from '../../../components'

const log = new Logger('Enrollment - Loading')

export const LoadingPage: FC = () => {
  const { t } = useTranslation('features-enrollment')
  const { navigate } = useRouter()
  const [step, setStep] = useState(0)

  // const { data, isLoading, error } = useGetEnrollmentLoadingData()
  const { mutate: submit, isLoading: isSubmitting, error: submitError } = useSubmitEnrollmentLoadingData()

  const onSubmit = useCallback(async (): Promise<void> => {
    try {
      const response = await submit({
        proceedLoading: true,
      })
      if (response?.path) {
        navigate(response.path)
      } else {
        // TODO: Handle the case when path is not returned
        navigate(ROUTES.HOME.path)
      }
    } catch (e) {
      log.error('Error submitting email', e)
    }
  }, [submit, navigate])

  useEffect(() => {
    const interval = setInterval(() => {
      setStep((prevStep) => {
        if (prevStep < 2) {
          return prevStep + 1
        }

        clearInterval(interval)
        void onSubmit()
        return prevStep
      })
    }, 2000)

    return () => {
      clearInterval(interval)
    }
  }, [onSubmit])

  return (
    <EnrollmentLayout title="Enrollment">
      <div className="egw-container-enroll h-full flex flex-col">
        {/* Loading initial data to make sure the user has access to this screen and retreive data based on user enrollment application */}
        {/* {isLoading ? (
          <SkeletonTheme baseColor="#eeefee" highlightColor="rgba(255, 255, 255, 0.5)">
            <Skeleton count={1} height="100px" className="mb-10" />
            <Skeleton count={5} height="50px" />
          </SkeletonTheme>
        ) : null} */}

        {/* In some cases initial data can be null, so we assume if it's not loading and there's no error - we show the page */}
        {!submitError ? (
          <div className="flex flex-col justify-center items-center flex-1">
            <LoadingAnimation />
            <p className="typo-primary-xl-light mt-md">{t(`investments.loading.step${step.toString()}`)}</p>
          </div>
        ) : null}

        {/* This error handles the case when the initial data is not loaded, for example network error */}
        {submitError ? (
          <div className="flex-1 flex flex-col justify-start md:justify-center">
            <GenericError errorMessage={t('common.generic_error')} />
          </div>
        ) : null}
      </div>
    </EnrollmentLayout>
  )
}
